<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="dialogVisible"
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`${tipAdd()}任务阶段`"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction">
            <el-form class="publish-form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="name" label="任务阶段">
                    <el-input v-model="ruleForm.name" placeholder="请输入">
                    </el-input>
                </el-form-item>
                <el-form-item prop="t_mid" label="负责人">
                    <el-select v-model="ruleForm.t_mid" placeholder="请选择" filterable>
                        <el-option
                            v-for="item in members"
                            :key="item.mid"
                            :label="item.name"
                            :value="item.mid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="end_time" label="完成时间">
                    <el-date-picker v-model="ruleForm.end_time"
                                    format="yyyy 年 MM 月 dd 日"
                                    placeholder="请选择"
                                    type="date" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button  @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import {tipAdd} from "@/utils/utils";
    import {addOutTaskStage, addTaskStage, getProjectMember, getProjectStatus} from "@/api";

    export default {
        name: "TaskAddStageDialog",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            pid: { //详情ID
                type: Number,
            },
            info: {
                type: Object
            }
        },
        data() {
            return {
                id:0,
                loading: false,
                ruleForm: {
                    name: '',
                    t_mid: '',
                    end_time: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入任务阶段', trigger: 'blur'}
                    ],
                    t_mid:[
                        {required: true, message: '请选择负责人', trigger: 'change'},
                    ],
                    end_time: [
                        {required: true, message: '请选择完成时间', trigger: 'blur'}
                    ],
                },
                members: [],
                is_outside:false, //审核通过后
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                let _data = await getProjectMember(this.pid)
                this.members = _data.data
                this.setData()
            },
            tipAdd(){
                return tipAdd(this.id,'添加')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addItem();
                    }
                });
            },
            async addItem() {
                this.loading = true
                let _data = this.is_outside ? await addOutTaskStage(this.pid,this.id, this.ruleForm.name, this.ruleForm.t_mid,this.ruleForm.end_time)
                    : await addTaskStage(this.pid,this.id, this.ruleForm.name, this.ruleForm.t_mid,this.ruleForm.end_time)
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState', {
                        type:'stage',
                        status:true,
                    })
                }
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            },
            async setData(){

                if (this.info) {
                    this.is_outside = this.info.is_outside === 1
                    this.id = this.info.id
                    this.ruleForm = {
                        name: this.info.name,
                        t_mid: this.info.t_mid,
                        end_time:this.info.end_time,
                    }
                } else {
                    let _data = await getProjectStatus(this.pid)
                    this.is_outside = _data.data.status ===  2
                    this.id = 0
                    this.ruleForm = {
                        name: '',
                        t_mid: '',
                        end_time: '',
                    }
                }
            }
        },
        watch: {
            info() {
                this.setData()
            }
        }
    }
</script>

<style scoped lang="scss">

</style>